import classNames from 'classnames'

import Paragraph from '../Paragraph'

type Schema = 'PRIMARY' | 'NETURAL' | 'SUCCESS' | 'WARNING' | 'ACCENT'

const bgColorSchema = {
  PRIMARY: 'bg-gray-900',
  NETURAL: 'bg-gray-50',
  SUCCESS: 'bg-green-100 border-green-600',
  WARNING: 'bg-red-100 border-red-500',
  ACCENT: 'bg-brand-accent1 border-gray-900',
}

const fgColorSchema = {
  PRIMARY: 'text-white',
  NETURAL: 'text-gray-900',
  SUCCESS: 'text-green-600',
  WARNING: 'text-red-500',
  ACCENT: 'text-gray-900',
}

const Badge = ({
  children,
  schema = 'PRIMARY',
}: {
  children: React.ReactNode
  schema: Schema
}) => (
  <span
    className={classNames([
      'inline-flex px-2 py-1 justify-center items-center gap-2 rounded-full border',
      bgColorSchema[schema],
    ])}
  >
    <Paragraph size="XS" className={fgColorSchema[schema]}>
      {children}
    </Paragraph>
  </span>
)

export default Badge
